var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowKpiDown({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 13,
    viewBox: "0 0 10 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.75 1.25C5.75 0.835786 5.41421 0.5 5 0.5C4.58579 0.5 4.25 0.835786 4.25 1.25V9.86358L1.29526 6.73503C1.01085 6.4339 0.536173 6.42033 0.235034 6.70474C-0.0661044 6.98915 -0.0796667 7.46383 0.204742 7.76497L4.45474 12.265C4.59642 12.415 4.79366 12.5 5 12.5C5.20635 12.5 5.40358 12.415 5.54526 12.265L9.79526 7.76497C10.0797 7.46383 10.0661 6.98915 9.76497 6.70474C9.46383 6.42033 8.98915 6.4339 8.70474 6.73503L5.75 9.86358V1.25Z",
    fill: "#DC1631"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowKpiDown);
export default __webpack_public_path__ + "static/media/arrow-kpi-down.1fb4ae3a.svg";
export { ForwardRef as ReactComponent };